function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "36",
  height: "36",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.907 26.448a.498.498 0 01-.31-.145l-4.95-4.95a.5.5 0 01.707-.707l4.621 4.622 4.621-4.622a.5.5 0 01.707.708l-4.95 4.95a.498.498 0 01-.31.144zM18.043 9.5c.113.01.224.058.31.145l4.95 4.95a.5.5 0 01-.707.706l-4.621-4.621-4.621 4.621a.5.5 0 01-.708-.707l4.95-4.95a.498.498 0 01.311-.144z",
  fill: "#54585D"
}))));